{
  "_provenance": {
    "ns": "profile",
    "source": "components/ProfileDialog and its sections (#2109 R3 lane L7)"
  },
  "fields": {
    "altEmail": "Alt email",
    "bioPlaceholder": "Tell us a bit about yourself…",
    "city": "City",
    "firstName": "First name",
    "lastName": "Last name",
    "phone": "Phone",
    "state": "State",
    "street": "Street",
    "zip": "ZIP"
  },
  "google": {
    "alreadyLinked": "That Google account is already linked to another TRF account.",
    "linkedAs": "Linked to <strong>{{email}}</strong>. You can sign in with Google.",
    "notLinked": "Link a Google account to sign in with Google instead of your password.",
    "unlink": "Unlink",
    "unlinking": "Unlinking…"
  },
  "header": {
    "roles": {
      "admin": "Admin",
      "applicant": "Applicant",
      "parent": "Parent",
      "trfer": "TRFer"
    },
    "roleSince": "{{role}} · Member since {{date}}"
  },
  "load": {
    "failed": "Couldn’t load your profile. Try again below.",
    "retry": "Retry"
  },
  "mfa": {
    "addPhoneFirst": "Add a phone number above first",
    "addPhoneHint": "Add a phone number above to enable text codes.",
    "chooseMethod": "Choose where to receive verification codes.",
    "codeLabel": "6-digit code",
    "currentPassword": "Current password",
    "differentMethod": "Use a different method",
    "disable": "Disable",
    "disablePrompt": "Enter your current password to disable two-factor.",
    "disabling": "Disabling…",
    "email": "Email",
    "enable": "Enable",
    "offDescription": "Add a second step at sign-in. Codes go to your email or phone.",
    "onEmail": "On — codes go to your <strong>email</strong>.",
    "onPhone": "On — codes go to your <strong>phone</strong>.",
    "sentTo": "We sent a code to <strong>{{destination}}</strong>. Enter it below to finish.",
    "text": "Text",
    "verify": "Verify",
    "verifying": "Verifying…"
  },
  "password": {
    "confirm": "Confirm new password",
    "current": "Current password",
    "help": "Fill all three to change your password on Save. Leave blank to keep it.",
    "new": "New password"
  },
  "sections": {
    "address": "Address",
    "bio": "Bio",
    "changePassword": "Change password",
    "google": "Google account",
    "mfa": "Two-factor authentication",
    "personalInfo": "Personal info"
  },
  "toasts": {
    "bothUpdated": "Profile and password updated",
    "codeInvalid": "That code isn’t valid. Request a new one and try again.",
    "codeNotSent": "Couldn’t send the code",
    "codeNotSentDescription": "The code wasn’t sent. Please try again.",
    "codesToEmail": "Codes will go to your email.",
    "codesToPhone": "Codes will go to your phone.",
    "disableFailed": "Couldn’t turn off two-factor authentication",
    "disableStillOn": "Two-factor is still on. Please try again.",
    "disableWrongPassword": "That password isn’t correct. Two-factor is still on.",
    "finishPassword": "Finish the password change",
    "finishPasswordDescription": "Fill all three password fields, or clear them to save profile changes only.",
    "googleLinked": "Google account linked",
    "googleLinkFailed": "Couldn’t link that Google account",
    "googleLinkFailedDescription": "Please try again.",
    "googleUnlinked": "Google account unlinked",
    "googleUnlinkFailed": "Couldn’t unlink your Google account",
    "loggingOut": "Logging you out now…",
    "mfaAutoDisabledDescription": "Your contact info changed — re-enable two-factor from the Security section.",
    "mfaDisabled": "Two-factor disabled",
    "mfaEnabled": "Two-factor enabled",
    "notSaved": "Your changes weren’t saved. Please try again.",
    "passwordMismatch": "Passwords do not match",
    "passwordNotChanged": "Password not changed",
    "passwordNotChangedDescription": "Your password wasn’t changed. Please try again.",
    "passwordUpdated": "Password updated",
    "passwordWrong": "The current password you entered was wrong. Try again.",
    "profileSavedPasswordNot": "Profile saved, password not changed",
    "profileUpdated": "Profile updated",
    "saveFailed": "Couldn’t save your profile",
    "updateFailed": "Couldn’t update your profile",
    "verifyFailed": "Couldn’t verify the code"
  }
}
